import DemoPage from "./pages/DemoPage";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import CGRPage from "./pages/CGRPage";
import JellyfishPage from "./pages/JellyfishPage";
import ENAPage from "./pages/ENAPage";
import GettingStartedPage from "./pages/GettingStartedPage";
import ConfigPage from "./pages/ConfigPage";

const router = createBrowserRouter([
    {path: "/", element: <GettingStartedPage/>},
    {path: "/docs", element: <GettingStartedPage/>},
    {path: "/demo", element: <DemoPage/>},
    {path: "/cgr", element: <CGRPage/>},
    {path: "/jellyfish", element: <JellyfishPage/>},
    {path: "/config", element: <ConfigPage/>},
    {path: "/ena", element: <ENAPage/>}
]);

function App() {

    return (
        <RouterProvider router={router}/>
    );
}

export default App;